import React from 'react';
import './add question.css'
import { MDBContainer,  MDBRow, MDBCol,MDBBtn,MDBIcon} from "mdbreact";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import allStrings from "../../assets/strings";
import { connect } from "react-redux";
import { withRouter,Redirect } from "react-router-dom";
import { BASE_END_POINT } from "../../urls";
import axios from "axios";
import { hasValue } from "../../validations/validations";
import { message } from "antd";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from 'draftjs-to-html';
import { EditorState, convertToRaw} from 'draft-js';

class AddQuestion extends React.Component {
    state = {
        question_en:'',
        question_ar:'',
        answer_ar:'',
        answer_en:'',
        imgs: [],
        imgsType:'data',
        imgsPreviewUrl: [],
        imgsName:[],
        editorState1: EditorState.createEmpty(),
        editorState2: EditorState.createEmpty(),
        contentState:{},
        
    };

    constructor(props){
        super(props)
        window.scrollTo(0,0)
        if(this.props.isRTL){
            allStrings.setLanguage('ar')
        }else{
            allStrings.setLanguage('en')
        } 
    }

    componentDidMount(){
        if(this.props.isRTL){
            allStrings.setLanguage('ar')
        }else{
            allStrings.setLanguage('en')
        } 
    }
    /**
    * add request
    */
    add = () => {
        const {question_en,question_ar,imgs,answer_ar,answer_en} = this.state
        let l = message.loading('Wait..', 2.5)
        
        if(hasValue(question_en)&&hasValue(question_ar)&&hasValue(answer_ar)&&hasValue(answer_en)){
            
           
            var data = new FormData()
            data.append('question_en',question_en)
            data.append('question_ar',question_ar)
            data.append('answer_ar',answer_ar)
            data.append('answer_en',answer_en)
            if(imgs != null){
                for(var i=0 ; i<= imgs.length-1 ; i++){
                    data.append(`imgs`,imgs[i] )
                } 
            }
           
            axios.post(`${BASE_END_POINT}questions`,data,{
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization':`Bearer ${this.props.currentUser.token}`,
                'Accept-Language':this.props.isRTL?'ar':'en'
            },
            })
            .then(response=>{
            console.log("AddQuestion UPDATED  ",response.data)
            l.then(() => message.success(allStrings.done, 2.5) )
            this.props.history.goBack() 
            })
            .catch(error=>{
                console.log(error.response)
                l.then(() => message.error(error.response.data.errors.msg[0].msg, 2.5))
            })
        }
    }
    
    /**
      * form submit Handler
    */
    submitHandler = event => {
        event.preventDefault();
        console.log(event.target.className)
        event.target.className += " was-validated";
        this.add()
    };
    /**
      * form inputs Handler
    */
    changeHandler = event => {
        this.setState({ [event.target.name]: event.target.value });
    };
    /**
      * upload files
      */
    fileChangedHandler = (event) => {
        let imgs =[];
        let imgsPreviewUrl = [];
        let imgsName = []
        for(var i=0 ; i<= event.target.files.length-1 ; i++){
            imgsPreviewUrl.push(URL.createObjectURL(event.target.files[i]))
            imgsName.push(event.target.files[i].name)
        }
        imgs.push(event.target.files)
        this.setState({
            imgs: event.target.files,
            imgsType:'data',
            imgsPreviewUrl:imgsPreviewUrl,
            imgsName:imgsName
        });
        
    };
    /**
      * remove files
    */
    removeFile = (url) => {
        let arr = this.state.imgsPreviewUrl;
        let arr2 =  Array.from(this.state.imgs);
        let arr3 = Array.from(this.state.imgsName)
        var index = arr.indexOf(url);
        if (index !== -1) arr.splice(index, 1);
        if (index !== -1) arr2.splice(index, 1);
        if (index !== -1) arr3.splice(index, 1);
        this.setState({
            imgsPreviewUrl: arr,
            imgs:arr2,
            imgsName:arr3
        });
        if(arr2.length === 0){
            this.setState({
            imgs:null,
            imgsName:[]
            });
        }

    };
    /**
    * convert text to html
    */
    onEditorStateChange1= (editorState) => {
        let contentBlock = draftToHtml(convertToRaw(editorState.getCurrentContent()))
        console.log("onEditorStateChange",contentBlock)
        if(contentBlock) {
            this.setState({
                editorState1: editorState,
                answer_en:contentBlock
            });
        }
    };
    /**
    * convert text to html
    */
    onEditorStateChange2 = (editorState) => {
        let contentBlock = draftToHtml(convertToRaw(editorState.getCurrentContent()))
        console.log("onEditorStateChange",contentBlock)
        if(contentBlock) {
            this.setState({
                editorState2: editorState,
                answer_ar:contentBlock
            });
        }
    };
    onContentStateChange1 =(contentState) => {
        console.log("contentState1",contentState)
    };
    onContentStateChange2 =(contentState) => {
        console.log("contentState2",contentState.blocks[0].text)
    };
    /**
    * upload Image in html
    */
   uploadImageCallBack(file) {
       console.log(file);
       return new Promise(
           (resolve, reject) => {
            var data = new FormData()
            data.append(`img`,file )
            axios.post(`${BASE_END_POINT}gifts/upload`,data,{
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization':`Bearer ${this.props.currentUser.token}`,
                'Accept-Language':this.props.isRTL?'ar':'en'
            },
            })
            .then(response=>{
                console.log(response.data.images[0]);
                resolve({data: {link: response.data.images[0]}})
            })

            .catch(error=>{
                console.log(error.response)
                reject(error.response);
            })
           }
       );
   }
  render(){
    const { editorState1, editorState2} = this.state;
   /**
    * config the editor state
    */
    const toolbar = {
        inline: {
            inDropdown: false,
        },
        list: { inDropdown: true },
        textAlign: { inDropdown: true },
        link: { inDropdown: true },
        history: { inDropdown: true },
        emoji  :  {inDropdown: false},
        image: { 
            uploadEnabled: true,
            previewImage: true,
            inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
            defaultSize: {
                height: '200',
                width: '200',
            },
            uploadCallback: this.uploadImageCallBack.bind(this), 
            alt: { present: true, mandatory: false } 
        },
    };
    const styles = {
        editor:{
            "border": "1px solid #F1F1F1",
            "padding": 5,
            "border-radius": 2,
            "height": "auto",
            "min-height": 200,
            "color":"#333"
        }
    }
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('FAQ')) return <Redirect to='/Home' />
  return (
    <div className="App">
        <MDBContainer> 
            <MDBRow>  
                <MDBCol md="12">
                    <div className="infoCard">
                        <Card className="editCard" style={{overflow: 'visible',outline:'none',marginBottom:'0px'}}>
                        <CardMedia
                        style={{height:"0px"}}
                        />
                        <CardHeader></CardHeader>
                        <div  style={{flexDirection: this.props.isRTL?'row-reverse':'row',display: 'flex'}}>
                            <div className="topIcon" style={{background:'#117183'}}>
                                <span className="material-icons" style={{color:'white',fontSize:23}}>help_outline</span>
                            </div>
                            <div className="tableTitle" style={{display:this.props.isRTL?'inline-block':'inline-block',marginTop:this.props.isRTL?'-60px':'-60px',
                            marginLeft:this.props.isRTL?'0':'0rem',marginRight:this.props.isRTL?'0rem':'0'}}>
                            <p>{allStrings.AddQuestion}</p>
                            </div>
                        </div>
                        <CardContent style={{minHeight:"390px",outline:'none'}}>
                        <MDBContainer>
                            
                            <MDBRow>
                                <MDBCol md="12">
                                <form
                                className="needs-validation"
                                onSubmit={this.submitHandler}
                                noValidate
                                >
                                    
                                    <div className="grey-text">
                                    <MDBRow>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                            <label htmlFor="form65" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.englishQuestion}</label>
                                            <input onInput={(e) =>e.currentTarget.value = e.currentTarget.value.replace(/[^A-Za-z0-9\s]/g,'') }  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.question_en} type="text" id="form645" name="question_en" className="form-control" onChange={this.changeHandler} required  validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                            <label htmlFor="form56" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.arabicQuestion}</label>
                                            <input onInput={(e) =>e.currentTarget.value = e.currentTarget.value.replace(/^[A-Za-z0-9 ]+$/g,'') } style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.question_ar} type="text" id="form56" name="question_ar" className="form-control" onChange={this.changeHandler} required validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow>
                                      <MDBCol md="12">
                                      <label htmlFor="form65" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.englishAnswer}</label>
                                        <Editor
                                            editorState={editorState1}
                                            editorClassName={styles.editor}
                                            toolbarClassName="toolbar-class"
                                            wrapperStyle={{
                                                minHeight: 100,
                                            }}
                                            editorStyle={{
                                                minHeight: 100,
                                                border: "1px solid #F1F1F1",
                                                padding: 5,
                                                borderRadius: 2,
                                                height: "auto",
                                            }}
                                            toolbar={toolbar}
                                            onContentStateChange={this.onContentStateChange1}
                                            onEditorStateChange={this.onEditorStateChange1.bind(this)}
                                        />
                                      </MDBCol>
                                    </MDBRow>
                                    <br></br>
                                    <MDBRow>
                                      <MDBCol md="12">
                                      <label htmlFor="form65" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.arabicAnswer}</label>

                                        <Editor
                                            editorState={editorState2}
                                            ref='textEditor'
                                            editorClassName={styles.editor}
                                            toolbarClassName="toolbar-class"
                                            wrapperStyle={{
                                                minHeight: 100,
                                            }}
                                            editorStyle={{
                                                minHeight: 100,
                                                border: "1px solid #F1F1F1",
                                                padding: 5,
                                                borderRadius: 2,
                                                height: "auto",
                                            }}
                                            toolbar={toolbar}
                                            onContentStateChange={this.onContentStateChange2}
                                            onEditorStateChange={this.onEditorStateChange2.bind(this)}
                                        />
                                      </MDBCol>
                                    </MDBRow>
                                   
                                    </div>
                                    <br></br>
                                    <br></br>
                                    <br></br>
                                    <br></br>
                                    <br></br>
                                    <br></br>
                                    <br></br>
                                    <br></br>
                                    <div className="text-center">
                                        <MDBBtn
                                        style={{background:'#117183',color:'#fff'}}
                                        rounded
                                        type="submit"
                                        color="#117183"
                                        className="btn-block z-depth-1a"
                                        >
                                        <MDBIcon icon="plus" className="mr-2" />
                                            {allStrings.add}          
                                        </MDBBtn>
                                       
                                    </div>
                                </form>
                                </MDBCol>
                            </MDBRow>
                        </MDBContainer>
                        </CardContent>
                    </Card>
                </div>
            </MDBCol>
            </MDBRow>
      </MDBContainer>
      
    </div> 
  )
  }
}


const mapToStateProps = (state) => ({
    isRTL: state.lang.isRTL,
    currentUser: state.auth.currentUser,
  });
  
  const mapDispatchToProps = {
  };
  
  export default withRouter(
    connect(mapToStateProps, mapDispatchToProps)(AddQuestion)
  );